import React from "react";
import FastMarquee from "react-fast-marquee";
import { TOTAL_COUNTRIES, TOTAL_DESTINATIONS } from "@/data/destinations";

const items = [
  `${TOTAL_DESTINATIONS}+ Destinations`,
  `${TOTAL_COUNTRIES} Countries`,
  "Curated Luxury Stays",
  "Private Sourcing Specialists",
  "Confirmation in 24 hours",
];

export const Marquee = () => (
  <div
    data-testid="marquee-strip"
    className="border-y border-aio-border/70 bg-aio-bg py-5"
  >
    <FastMarquee gradient={false} speed={40} pauseOnHover>
      {items.concat(items).map((t, i) => (
        <span
          key={i}
          className="mx-10 text-[11px] uppercase tracking-[0.32em] text-aio-soft"
        >
          {t}
          <span className="mx-10 text-aio-border">/</span>
        </span>
      ))}
    </FastMarquee>
  </div>
);
